import React from "react";
import {
  Box,
  Button,
} from "@chakra-ui/react";
import { FormChecklist } from "../../components/FormChecklist";
import { useCreateCatalog } from "./useCreateCatalog"
import { LoadingOverlay } from "../../components/LoadingOverlay";
import { FormInput } from "../../components/FormInput";
import { HelmetComponent } from "../../components/HelmetComponent";

export const CreateCatalogPage = ({
  isHidden,
  isNoPadding = false
}) => {
  const {
    catalog,
    catalogSubmit,
    staff,
    onChange,
    catalogAdmins,
    checklistCallback,
    buttonText,
    loading,
    user
  } = useCreateCatalog();

  return (
    <>
      <HelmetComponent title={`Create Catalog - Home - ${user.firstName} ${user.lastName}`}/>
      {loading && <LoadingOverlay />}
      <Box isNoPadding={isNoPadding}>
        <form onSubmit={catalogSubmit}>
          <FormInput
            label="Catalog Name"
            name="catalogName"
            type="text"
            inputOnChange={onChange}
            value={catalog.catalogName}
            formProps={{ isRequired: true }}
            padding="0"
          />
          <FormInput
            label="Heading"
            name="heading"
            type="text"
            inputOnChange={onChange}
            value={catalog.heading}
            formProps={{ isRequired: true }}
            padding="20px 0 0"
          />
          <FormInput
            label="Sub Heading"
            name="subHeading"
            type="text"
            inputOnChange={onChange}
            value={catalog.subHeading}
            formProps={{ isRequired: true }}
            padding="20px 0 0"
          />
          <FormInput
            label="Description"
            name="description"
            type="text"
            inputOnChange={onChange}
            value={catalog.description}
            formProps={{ isRequired: true }}
            padding="20px 0 0"
          />
          <FormChecklist
            name="Assigned Catalog Admins"
            checkList={staff}
            selectedList={catalogAdmins}
            checklistCallback={(list) => checklistCallback(list)}
            padding="20px 0 0"
            itemPerRow={4}
            isRequired={true} />
          <Button
            colorScheme="blue"
            fontWeight="800"
            background="#1b6ec2"
            type="submit"
            disabled={catalogAdmins.length === 0}
            margin="20px 0 0"
          >
            {buttonText}
          </Button>
        </form>
      </Box>
    </>
  );
};
